export default __webpack_public_path__ + "static/media/download-icon.6ebb9e0f.svg";